import React from 'react';
import PropTypes from 'prop-types';
import { closeIconSvg } from '../../HelperMethods/constants';

const FormHeader = (props) => {
  // eslint-disable-next-line no-unused-vars
  const { title, onCancel, hideButton = false } = props;
  return (
    <div className="form-header">
      {title}
      {!hideButton && (
        <div style={{ position: 'absolute', right: '26px', bottom: '0px' }}>
          <button
            type="button"
            className="transparent-button"
            onClick={() => {
              onCancel();
            }}
          >
            <img
              src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(closeIconSvg)}`}
              style={{ cursor: 'pointer' }}
              alt="Close Icon"
            />
          </button>
        </div>
      )}
    </div>
  );
};

FormHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  hideButton: PropTypes.bool,
};

export default FormHeader;
